export const fetchApiRequestBody = (data: any) => {
  const body = {
    bankId: data?.bankId ?? '',
    cityId: data?.cityId ?? '',
  }
  return body
}
